import React, { useState, useEffect } from "react";
import "./homePage.css";
import AnimatedSCanvas from "./AnimatedSCanvas";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

const texts = [
  "IT Solution & Services ",
  "Web App Developments",
  "Mobile App & Services",
];

const highlightWords = ["Services", "Web App"];

const HighlightedText = ({ text }) => {
  const sortedWords = [...highlightWords].sort((a, b) => b.length - a.length);
  const escapeRegExp = (string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const pattern = sortedWords.map(escapeRegExp).join("|");
  const regex = new RegExp(`(${pattern})`, "gi");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <span key={index} className="highlight-word">
            {part}
          </span>
        ) : (
          part
        )
      )}
    </>
  );
};

const ChangingText = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <span className="changingTexthome">
      <HighlightedText text={texts[index]} />
    </span>
  );
};

const HomePage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    AOS.refresh();
  }, []);

  return (
    <section className="hero-section-container">
      <div className="hero-left" data-aos="fade-right">
        <h1 className="HomePageTitle">
          <ChangingText />
        </h1>
        <p className="HomePageDescription">
          Turn your Software idea with SAAS into reality, with our expert
          guidance, we will help you to build a scalable and profitable SAAS
          product.
        </p>
        <p className="QuestionTitle">
          "Are you ready to build your custom application solution?"
        </p>
        <Link to="/contactform">
          <button className="talkToOurExpertButton border-gradient border-gradient-purple">
            Talk to Our Experts
          </button>
        </Link>
      </div>

      <div className="hero-right" data-aos="fade-left">
        <AnimatedSCanvas />
        <div className="cursor-overlay"></div>
      </div>
    </section>
  );
};

export default HomePage;


// new code-----------

// import React, { useState, useEffect } from "react";
// import "./homePage.css";
// import AnimatedSCanvas from "./AnimatedSCanvas";
// import { Link } from "react-router-dom";

// // AOS imports--------------------
// import AOS from "aos";
// import "aos/dist/aos.css";

// // Dynamic lines
// const texts = [
//   "IT Solution & Services ",
//   "Web App Developments",
//   "Mobile App & Services",
// ];

// // Words to highlight
// const highlightWords = [
//   "Services",
//   "Web App",
//   // "Digital Reality",
//   // "Technology",
//   // "custom application solution",
// ];

// // Highlight component
// const HighlightedText = ({ text }) => {
//   const sortedWords = [...highlightWords].sort((a, b) => b.length - a.length);
//   const escapeRegExp = (string) =>
//     string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

//   const pattern = sortedWords.map(escapeRegExp).join("|");
//   const regex = new RegExp(`(${pattern})`, "gi");
//   const parts = text.split(regex);

//   return (
//     <>
//       {parts.map((part, index) =>
//         regex.test(part) ? (
//           <span key={index} className="highlight-word">
//             {part}
//           </span>
//         ) : (
//           part
//         )
//       )}
//     </>
//   );
// };

// // Rotating text component
// const ChangingText = () => {
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIndex((prev) => (prev + 1) % texts.length);
//     }, 3000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <span className="changingTexthome">
//       <HighlightedText text={texts[index]} />
//     </span>
//   );
// };

// // Main HomePage component
// const HomePage = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//     AOS.refresh();
//   }, []);

//   return (
//     <section className="hero-section-container">
//       <AnimatedSCanvas />

//       <div
//         className="hero-content"
//         style={{
//           position: "relative",
//           zIndex: 1,
//           color: "#fff",
//           textAlign: "center",
//           top: "50%",
//           transform: "translateY(-50%)",
//         }}
//         y
//         data-aos="zoom-in"
//       >
//         <div className="text-content">
//           <h1 className="HomePageTitle">
//             <ChangingText />
//           </h1>
//           <br />
//           <span className="HomePageDescription">
//             Turn your Software idea with SAAS into reality, with our expert
//             guidance, we will help you to build a scalable and profitable SAAS
//             product.
//             <p className="QuestionTitle">"Are you ready to build your custom application solution?",</p>
//           </span>

//           <div className="talkToOurExpertContainer">
//             <Link to="/contactform">
//               <button className="talkToOurExpertButton border-gradient border-gradient-purple">
//                 Talk to Our Experts
//               </button>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HomePage;



// old code with left and right section 
// import React, { useState, useEffect } from "react";
// import "./homePage.css";
// import homePageImage from "../../assets/background_Image/1.png";
// // import bgVideo from "../../assets/background_Image/video2";
// import AnimatedSCanvas from '../SbgImage/AnimatedSCanvas';

// import { Link } from "react-router-dom";
// const ChangingText = () => {
//   const texts = [
//     "IT Solution & Services ",
//     "Web App Developments",
//     "Mobile App & Services",
//     "Empowering Ideas with Cutting-Edge Web & App Solutions",
//     "Transforming Visions into Digital Reality",
//     "Bringing Your Bright Ideas to Life with Technology",
//     "Are you ready to build your custom application solution?",
//     "You can’t afford to choose the wrong web developer",
//   ];
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIndex((prev) => (prev + 1) % texts.length);
//     }, 3000);
//     return () => clearInterval(interval);
//   }, []);

//   return <span className="changingTexthome">{texts[index]}</span>;
// };

// const HomePage = () => {
//   return (
//     <section style={{ height: '105vh', position: 'relative', overflow: 'hidden' }}>
//       <AnimatedSCanvas />
//       <div style={{
//         position: 'relative',
//         zIndex: 1,
//         color: '#fff',
//         textAlign: 'center',
//         top: '50%',
//         transform: 'translateY(-50%)'
//       }}>
//     <div className="hero-section">
//       <div className="content-wrapper">
//         <div className="text-content">
//           <h1 className="HomePageTitle">
//             <ChangingText />
//           </h1>

//           <div className="talkToOurExpertContainer">
//             <Link to="/contactform">
//               <button className="talkToOurExpertButton border-gradient border-gradient-purple">
//                 Talk to Our Experts
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* =======================image-content============================= */}
//         <div className="imageContainer">
//           {/* <video className="videoBackground" autoPlay muted loop playsInline>
//             <source src={bgVideo} type="video/mp4" />
//           </video> */}
//         </div>
//       </div>
//     </div>
//     </div>
//   </section>
//   );
// };

// export default HomePage;
